class DeliveryCostComponent extends HTMLElement {
    constructor() {
      super();
      this.deliveryPriceUnsubscriber = undefined;
      this.cartUpdateUnsubscriber = undefined;
      this.isRendered = false;
      this.lowestPrice = null;
    }
  
    connectedCallback() {
      if (window.lowestDeliveryPrice !== undefined && window.lowestDeliveryPrice !== null) {
        this.lowestPrice = window.lowestDeliveryPrice;
        this.renderDeliveryCost(window.lowestDeliveryPrice);
      } else {
        this.deliveryPriceUnsubscriber = subscribe(PUB_SUB_EVENTS.deliveryPriceLoaded, (data) => {
          this.lowestPrice = data.lowestPrice;
          this.renderDeliveryCost(data.lowestPrice);
        });
      }
  
      // Subscribe to cart updates specifically for the product form
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'product-form' && this.lowestPrice !== null) {
          this.showDeliveryPopup();
        }
      });
    }
  
    renderDeliveryCost(lowestPrice) {
      if (this.isRendered) return;
  
      const deliveryDateContainer = document.querySelector('.services-row--despatch-date');
      if (!deliveryDateContainer) return;
  
      const targetElement = deliveryDateContainer.querySelector('.services-column:nth-child(2) .services-text');
      if (!targetElement) return;
  
      const br = document.createElement('br');
      const costSpan = document.createElement('span');
      costSpan.className = 'delivery-cost';
      costSpan.textContent = `Delivery Cost: ${formatMoney(lowestPrice)}`;
      
      targetElement.appendChild(br);
      targetElement.appendChild(costSpan);
      
      this.isRendered = true;
    }
  
    showDeliveryPopup() {
      // Create popup container
      const popup = document.createElement('div');
      popup.className = 'delivery-cost-popup';
      popup.innerHTML = `
        <div class="delivery-cost-popup__content">
          <p>Delivered for ${formatMoney(this.lowestPrice)} - Add 1 or 100 items, delivery stays the same</p>
        </div>
      `;
  
      popup.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #fff;
        border: 2px solid #000;
        padding: 20px;
        z-index: 9999;
        max-width: 300px;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      `;
  
      document.body.appendChild(popup);
  
      // Auto-remove after 5 seconds
      setTimeout(() => {
        popup.remove();
      }, 5000);
    }
  
    disconnectedCallback() {
      if (this.deliveryPriceUnsubscriber) {
        this.deliveryPriceUnsubscriber();
      }
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }
  }
  
  customElements.define('delivery-cost-component', DeliveryCostComponent);
  